/**
 * Dark mode theme
 *
 * @experimental
 */
export var darkTheme = {
  grid: {
    stroke: '#3f3f46',
    fill: 'none'
  }
};